import { Component } from '@angular/core';

@Component({
    selector: 'app-sms-email-errors-landing',
    templateUrl: './sms-email-errors-landing.component.html',
    styleUrl: './sms-email-errors-landing.component.css',
})
export class SmsEmailErrorsLandingComponent {
    constructor() {}

    activeIndex: number = 0;

    ngOnInit() {}
}
